<template>
    <div ref="mobileW">
        <vue-headful :title="$t('my-group')" />

        <div class="mb-4 flex flex-wrap w-full">

            <feather-icon
                icon="GridIcon"
                @click="is_list = !is_list"
                class="p-2 mr-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                v-if="!is_list"
                :svgClasses="{'text-primary stroke-current': is_list === 'item-grid-view'}" />
            <feather-icon
                icon="ListIcon"
                @click="is_list = !is_list"
                v-else
                class="p-2 mr-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                :svgClasses="{'text-primary stroke-current': !is_list === 'item-list-view'}" />


            <multiselect
                v-model="studyPlanActive"
                class="speciality_select"
                :options="studyPlan"
                selectedLabel=""
                :placeholder="$t('speciality')"
                :custom-label="nameSpeciality"
                @remove="multiselectRemove"
                @select="multiselectAction"
                :loading="loading"
                deselectLabel=""
                selectLabel=""
                track-by="uid">
            </multiselect>

            <div class="sm:w-full sm:mt-2 md:w-full md:mt-0 lg:w-4/12">
                <vs-input :placeholder="$t('find-my-group')" v-model="SearchQuery" icon-pack="feather" icon="icon-search" size="medium" class="w-full lg:ml-2" icon-no-border />
            </div>

        </div>

        <!-- Список пользователей -->
        <div class="vx-row users_container" v-if="myGroup && !is_list">
            <div class="vx-col w-full lg:w-3/4 xl:w-3/4 xl:pr-10 group_wrapper">
                <h4 class="mb-4">{{$t('my_classmates')}}</h4>
                <transition-group name="flip-list" tag="div" class="cards cards_mobile" v-if="myGroup">
                    <UserCardSecond :item="item" v-for="(item, index) in filteredFaq" :key="`stud_${ index }`"/>
                </transition-group>
            </div>
            <div class="user_sidebar lg:pt-10 vx-col w-full lg:w-1/4 xl:w-1/4" v-if="MyEdvisor">
                <UserCardFirst :title="$t('my_adviser')" titleColor="primary"
                               :item="MyEdvisor"
                               v-if="MyEdvisor"
                               v-on:openChangeVisor="changeVisorModal($event)"
                               v-on:openStoryVisor="storyVisorModal($event)" />
            </div>
        </div>

        <div class="vx-row users_container" v-if="myGroup && is_list">
            <div class="vx-col w-full lg:w-3/4 xl:w-3/4 xl:pr-10 group_wrapper">
                <vx-card class="mt-base">
                    <UserList :title="$t('my_adviser')"  :item="MyEdvisor"  v-if="MyEdvisor" v-on:openChangeVisor="changeVisorModal($event)" v-on:openStoryVisor="storyVisorModal($event)"/>

                    <transition-group name="flip-list" tag="ul" v-if="myGroup">
                        <UserList :item="item2"  v-for="(item2, index2) in filteredFaq"  :key="`stud_list_${ index2 }`"/>
                    </transition-group>
                </vx-card>
            </div>
        </div>

        <!-- Выводим сообщение если студ план не выбран -->
        <vs-alert v-if="emptyMessage" active="true">
            {{$t('choose_a_specialty')}}
        </vs-alert>

        <!-- В этот див выводил лоадер -->
        <div id="infinite_loader" class="vs-con-loading__container"></div>

        <vs-popup :title="$t('change_adviser')"  :active.sync="popupFormActive" >
            <FormChangeVisor  v-on:close="popupFormActive = !popupFormActive" :Edvisor="MyEdvisor" :studyPlan="studyPlanActive"/>
        </vs-popup>

        <vs-popup :title="$t('history_adviser')"  :active.sync="popupStoryActive" >
            <TableStoreVisor/>
        </vs-popup>
    </div>
</template>

<script>
import axios from '@/configs/Axios'
import FormChangeVisor from './Popup/ChangeVisor'
import TableStoreVisor from './Popup/StoryVisor'
import UserCard from './UserCard'
import UserList from './UserListCard'
import UserCardSecond from './UserCardSecondDesing'
import UserCardFirst from './UserCardSecond'

export default {
    data() {
        return {
            studyPlan: [],
            MyEdvisor: null,
            studyPlanActive: null,
            loading: false,
            myGroup: [],
            popupFormActive:false,
            popupStoryActive:false,
            SearchQuery:'',
            is_list:false
        }
    },
    components: {
        UserCard,UserCardSecond,FormChangeVisor,TableStoreVisor,UserCardFirst,UserList
    },
    created: function() {
        // Запращиваем студ план
        this.fetchStudyPlan();
    },
    computed: {
        filteredFaq () {
            return this.myGroup.filter((student) => {
                return      student.firstName.toLowerCase().includes(this.SearchQuery.toLowerCase())
                    ||  student.lastName.toLowerCase().includes(this.SearchQuery.toLowerCase())
            })
        },
        emptyMessage() {
            // Если нет активного студ плана, показываем сообщение
            if(!this.studyPlanActive) return true
        },
        mobileW() {
            return this.$refs.mobileW.clientWidth;
        }
    },
    watch:{
        studyPlan(val){
            if (val.length>0){
                this.$route.meta.pageTitle = this.$t('my-group') +' '+ val[0].group
            }else{
                this.$route.meta.pageTitle = this.$t('my-group')
            }
        },
        loading() {
            if(this.mobileW <= 425) this.is_list = true
            else this.is_list = false
        }
    },
    methods: {
        nameSpeciality: data => data.education_program.name,
        multiselectRemove() {
            // Очищаем данные со студ планом и списком пользователей
            this.studyPlanActive = null
            this.myGroup = []
            this.MyEdvisor = null
        },
        changeVisorModal(val){
            this.popupFormActive = val;
        },
        storyVisorModal(val){
            this.popupStoryActive = val;
        },
        multiselectAction(item) {
            // Выбираем студ план и запрашиваем список пользователей
            this.studyPlanActive = item
            this.fetchMyGroup(item.uid)
        },
        async fetchStudyPlan() {
            // Запрашиваем студ план
            try {
                this.$vs.loading({
                    scale: 0.45
                })
                this.loading = true
                const {data} = await axios.get(`/user/my_study_plans_version2/`)
                this.studyPlan = data
                this.studyPlanActive = data[0]

                this.fetchMyGroup(this.studyPlanActive.uid)
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error_upload_admin'),
                    color: 'danger'
                })
            } finally {
                this.loading = false
                this.$vs.loading.close()
            }
        },
        async fetchAdvisor() {
            // Запрашиваем эдвайзера
            try {
                const {data} = await axios.get(`/user/my_roles/`)
                this.MyEdvisor = data.supervisors;
            } catch (e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            }
        },
        async fetchMyGroup(uid) {
            // Запрашиваем список пользователей
            try {
                this.$vs.loading({
                    container: '#infinite_loader',
                    scale: 0.6
                })

                const {data} = await axios.get('/user/my_groups/', { params: { study_plan: uid } })
                this.myGroup = data.students
                this.fetchAdvisor()
                // this.MyEdvisor = data.supervisors[0];
                // this.MyEdvisor.request_responsible = data.request_responsible;


            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close('#infinite_loader > .con-vs-loading')
            }
        },

    }
}
</script>

<style lang="scss">
.flip-list-move {
    transition: transform 1s;
}

.flip-list-item {
    transition: all 1s;
    display: inline-block;
    margin-right: 10px;
}
.flip-list-enter, .flip-list-leave-to
    /* .flip-list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
}
.flip-list-leave-active {
    position: absolute;
}

.speciality_select{
    .multiselect__single{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
@media only screen and (min-width: 901px) {
    .speciality_select{
        max-width: 300px;
    }
}
@media only screen and (min-width: 760px) {
    .group_wrapper{
        .vx-card{
            height: 100%;
        }
    }
}


</style>

<style scoped lang="scss">
#infinite_loader{
    padding: 20px 0;
    .con-vs-loading{
        background: transparent;
    }
}
.user_contact{
    .item{
        &:not(:last-child){
            margin-bottom: 10px;
        }
    }
}
@media only screen and (min-width: 960px) {
    .user_sidebar{
        .vx-card{
            &:not(:last-child){
                margin-bottom: 20px;
            }
        }
    }
}
@media only screen and (max-width: 960px) {
    .user_sidebar{
        .vx-card{
            margin-bottom: 20px;
        }
    }
    .users_container{
        flex-wrap: wrap-reverse;
    }
}

.cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(225px, 0fr));
    gap: 2rem;
    padding: 0;
    list-style-type: none;
}
@media only screen and (max-width: 992px){
    .cards_mobile{
        gap: 1rem;
        grid-template-columns: repeat(auto-fit, minmax(160px, 0fr));
    }
}

</style>
